// extracted by mini-css-extract-plugin
export default {"cityList":"styles_cityList__bf-hR","segmented":"styles_segmented__idmt-"};